'use strict';

module.exports = {
  initialise: function initialise(url) {
    var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var script = document.createElement('script');

    script.setAttribute('type', 'text/javascript');
    if (isAsync) {
      script.setAttribute('async', '');
    }
    script.setAttribute('src', url);
    script.setAttribute('id', 'salesforce-mcp');

    document.body.appendChild(script);
  }
};